import {Record} from 'immutable/dist/immutable';
import keyBy from 'lodash/keyBy';
import {List, Iterable} from 'immutable';

export const TriggerActionRecipientType = Object.freeze({
  TEAM: 'send_to_team',
  CALLER: 'send_to_caller',
  MANAGER: 'send_to_callers_manager',
  USER: 'send_to_user',
  ADDRESSES: 'send_to_addresses',
  SHARED_ME: 'send_to_shared_me',

  getTriggerActionRecipient: (triggerActionRecipientType, props = {}) => {
    // eslint-disable-next-line
    switch (triggerActionRecipientType) {
      case TriggerActionRecipientType.TEAM:
        return new SendToTeam(props);
      case TriggerActionRecipientType.CALLER:
        return new SendToCaller();
      case TriggerActionRecipientType.MANAGER:
        return new SendToCallersManager();
      case TriggerActionRecipientType.USER:
        return new SendToUser(props);
      case TriggerActionRecipientType.ADDRESSES:
        return new SendToAddresses(props);
      case TriggerActionRecipientType.SHARED_ME:
        return new SendToSharedMe(props);
    }
  },

  getTriggerActionRecipientValueMap: values => {
    const mapped = values
      .filter(item => item != null)
      .map(item => {
        return {
          type: item.type,
          value:
            item.userId || item.teamId || item.ruleId || (item.emails && item.emails.join(', ')),
        };
      });
    return keyBy(mapped, item => item.type);
  },
});

export class SendToTeam extends Record({
  type: TriggerActionRecipientType.TEAM,
  teamId: null,
}) {
  constructor(props) {
    super({
      ...props,
      teamId: props.teamId || props.value,
    });
  }
}

export class SendToCaller extends Record({
  type: TriggerActionRecipientType.CALLER,
}) {}

export class SendToUser extends Record({
  type: TriggerActionRecipientType.USER,
  userId: null,
}) {
  constructor(props) {
    super({
      ...props,
      userId: props.userId || props.value,
    });
  }
}

export class SendToSharedMe extends Record({
  type: TriggerActionRecipientType.SHARED_ME,
}) {}

export class SendToCallersManager extends Record({
  type: TriggerActionRecipientType.MANAGER,
}) {}

export class SendToAddresses extends Record({
  type: TriggerActionRecipientType.ADDRESSES,
  emails: List(),
}) {
  constructor(props = {emails: List()}) {
    const emailValue = props.emails || SendToAddresses.stringToList(props.value);
    const emails = Iterable.isIterable(emailValue) ? emailValue : List(emailValue);
    super({
      ...props,
      emails,
    });
  }

  static stringToList(value, delim = ',') {
    if (!value) {
      return List();
    }

    const list = value.replace(' ', '').split(delim);
    return List(list.filter(i => i.length > 0));
  }

  listToString(delim = ',') {
    return this.emails && this.emails.size > 0 ? this.emails.toArray().join(delim) : '';
  }
}
